import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'

import Button from 'srcReact/components/common2/Button'
import InvitationItem from './InvitationItem'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'
import styles from './styles.module.scss'
import TooltipWrapper from 'srcReact/components/common2/TooltipWrapper'

const initList = (selection) =>
  selection
    .split(',')
    .filter((e) => e)
    .map((e) => parseInt(e))

const Invitation = ({ previousStep, goToPreviousStep, setPreviousStep, updateStep, formState, setFormState }) => {
  const { t } = useTranslation()

  const [selectedInvites, setSelectedInvites] = useState(initList(formState.workplaceInvitationsSelected))

  const handleClickInvite = (invite) => {
    const isAlreadyInsideList = selectedInvites.some((i) => i === invite.id)

    if (!isAlreadyInsideList) {
      setSelectedInvites([...selectedInvites, invite.id])
    } else {
      setSelectedInvites([...selectedInvites?.filter((i) => i !== invite.id)])
    }
  }

  const getColor = (key) => {
    const colors = ['orange', 'purple', 'blue']

    return colors[key % colors.length]
  }

  const invites = formState.workplace_invitations
    ?.filter((e) => {
      if (formState.orgId && formState.orgId > 0) {
        return e.organization_id.toString() == formState.orgId
      }
      return true
    })
    .map((e, i) => {
      let orgPicture = ''
      if (formState.organizations && formState.organizations.length > 0) {
        const orgObj = formState.organizations.find((org) => org.id === e.organization_id)
        if (orgObj) {
          orgPicture = orgObj.picture
        }
      }
      return (
        <InvitationItem
          key={i}
          letters={e.initials}
          name={e.name}
          color={e.color}
          organizationPicture={orgPicture}
          checked={selectedInvites.includes(e.id)}
          handleClick={() => {
            handleClickInvite(e)
          }}
        />
      )
    })

  const plural = invites?.length > 1 ? 's' : ''

  const finalResult = selectedInvites.join(',')
  const contentStyle = {
    background: colorVariables.darkgray,
    color: colorVariables.whitecolor,
    width: '19rem',
    height: '3rem',
    marginBottom: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        <div>
          {t('signup.invitation_module.found')} {invites?.length} {t('signup.invitation_module.invitation')}
          {plural} {t('signup.invitation_module.for')} {formState.email}
        </div>
        <div className={styles.change}></div>
        <div>{invites}</div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          text={t('signup.invitation_module.back')}
          size='large'
          style='secondary'
          handleClick={goToPreviousStep}
        />
        <TooltipWrapper
          position='bottom center'
          contentStyle={contentStyle}
          content={t('signup.invitation_module.join_tooltip')}
          triggerElement={
            <button
              type='button'
              className={styles.confirmButton}
              onClick={() => {
                setPreviousStep([...previousStep, 'invitation'])
                updateStep('password')
                setFormState({
                  ...formState,
                  workplaceInvitationsSelected: finalResult
                })
              }}>
              {t('signup.invitation_module.join')}
            </button>
          }
        />
      </div>
    </div>
  )
}

export default Invitation
